// extracted by mini-css-extract-plugin
module.exports = {"container":"overlay_container__1TUhY","item":"overlay_item__2bPHS","bubble":"overlay_bubble__1yoZb","like":"overlay_like__2WMUU"};